export default __webpack_public_path__ + "static/media/cssBW.2d52fd0d.webp";